// Canonical push-payload → in-app route mapping.
// One pure function so every notification type has exactly one destination
// (server payload contract documented in docs/deep-linking-scoping.md).
export function notificationToRoute(data: Record<string, any> | null | undefined): string | null {
  if (!data) return null;
  if (data.type === 'group_chat' && data.group_id) {
    // chat pushes open the pack screen directly on the Plan-a-walk tab
    return `/group/${data.group_id}?view=chat`;
  }
  if (data.type === 'group_invite' && data.group_id) {
    return `/group/${data.group_id}`;
  }
  if (data.trail_id) {
    return `/trail/${data.trail_id}`;
  }
  if (data.type === 'achievement' || data.deep_link === 'collectible') {
    return '/(tabs)/collectible';
  }
  return null;
}